import classNames from 'classnames';
import { ReactNode } from 'react';
import { Row, Checkbox, ICheckboxProps } from '@busybusy/webapp-react-ui';

import './CheckItem.scss';

export interface ICheckItemProps extends ICheckboxProps {
  className?: string | object;
  children: ReactNode;
}

function CheckItem(props: ICheckItemProps) {
  const { children, className, ...checkboxProps } = props;

  const classes = classNames(
    {
      'check-item': true,
    },
    className
  );

  return (
    <Row className={classes}>
      <Checkbox {...checkboxProps} />
      {children}
    </Row>
  );
}

CheckItem.defaultProps = {
  ...Checkbox.defaultProps,
};

export default CheckItem;
